<app-card
  #cardComponent
  [title]="'PEOPLE_FORM.FORM.FINANCIAL_INFORMATION.SUBTITLE' | translate"
  [index]="index()"
  (deleteCard)="remove.emit()"
  [totalItems]="totalItems()"
  optional
>
  <app-form-area
    hiddenButtons
  >
    <app-payment-methods-select
      [control]="control().get('paymentMethodId')"
    />
    <div class="slide-toggle-container">
      <mat-slide-toggle
        labelPosition="before"
        [checked]="control().get('isMain')?.value"
        (change)="control().get('isMain')?.setValue($event.checked)"
        color="primary"
      >
      {{ 'PEOPLE_FORM.FORM.FINANCIAL_INFORMATION.IS_MAIN' | translate }}
    </mat-slide-toggle>
  </div>
  </app-form-area>
</app-card>
